/**
 * askChatPolicy — Ask Led chat is read-only for now: it must not surface
 * suggestions or follow-ups that would create, assign, or modify records.
 * Used by the backend (filtering model output + suggestions) and by the
 * frontend (filtering threads persisted before the gate existed).
 */

const MUTATING_START =
  /^(create|add|make|build|assign|reassign|update|edit|modify|change|set|mark|close|complete|resolve|finish|delete|remove|void|archive|sync|upload|attach|schedule|draft|send|log|approve|reject|reopen|rename|move|convert)\b/i;

export function isMutatingSuggestion(label: string): boolean {
  return MUTATING_START.test(label.trim());
}
